export const SAMPLES_EXPORT_LIMIT = 250;

export function isSamplesExport(loadOptions = {}) {
  return loadOptions.isLoadingAll === true;
}

export function applySamplesExportPagination(params, loadOptions = {}) {
  if (!isSamplesExport(loadOptions)) {
    return params;
  }

  const queryParams = String(params || '')
    .replace(/^\?/, '')
    .split('&')
    .filter(Boolean)
    .filter((param) => !/^(offset|limit)=/.test(param));

  queryParams.push('offset=0', `limit=${SAMPLES_EXPORT_LIMIT}`);

  return `?${queryParams.join('&')}`;
}
